import { render, staticRenderFns } from "./Mbti.vue?vue&type=template&id=36e6a03c&scoped=true"
import script from "./Mbti.vue?vue&type=script&lang=js"
export * from "./Mbti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6a03c",
  null
  
)

export default component.exports